import { COLLECTIONS, FIELDS, PROVIDER } from "./constants";
import { replaceApiUrl } from "./helpers";
import { supabase } from "./supabase";

export async function getFeaturedPosts() {
  const { data, error } = await supabase
    .from(COLLECTIONS.blog)
    .select("*")
    .range(0, 2)
    .order(FIELDS.created_at, { ascending: false });

  if (error) throw error;
  return data;
}

export async function getProviders(limit, offset) {
  const { data, error } = await supabase
    .from(COLLECTIONS.profile)
    .select("*")
    .eq(FIELDS.account, PROVIDER)
    .neq(FIELDS.slug, null)
    .range(offset, limit)
    .order(FIELDS.created_at, { ascending: false });

  if (error) throw error;
  return data.map(d => replaceApiUrl(d));
}

export async function getProviderBySlug(slug) {
  const { data, error } = await supabase
    .from(COLLECTIONS.profile)
    .select("*")
    .eq(FIELDS.slug, slug);
  if (error) throw error;

  return replaceApiUrl(data[0]);
}

export async function getPosts(limit, offset) {
  const { data, error } = await supabase
    .from(COLLECTIONS.blog)
    .select("*")
    .range(offset, limit)
    .order(FIELDS.created_at, { ascending: false });

  if (error) throw error;
  return data;
}

export async function getRelatedPosts(category, excludePostId) {
  const { data, error } = await supabase
    .from(COLLECTIONS.blog)
    .select("*")
    .eq(FIELDS.category, category)
    .neq(FIELDS.id, excludePostId)
    .range(0, 2)
    .order(FIELDS.created_at, { ascending: false });

  if (error) throw error;
  return data;
}

export async function getPostsByCategory(category, limit, offset) {
  const { data, error } = await supabase
    .from(COLLECTIONS.blog)
    .select("*")
    .eq(FIELDS.category_slug, category)
    .range(offset, limit)
    .order(FIELDS.created_at, { ascending: false });

  if (error) throw error;
  return data;
}

export async function getPostBySlug(slug) {
  const { data, error } = await supabase
    .from(COLLECTIONS.blog)
    .select("*")
    .eq(FIELDS.slug, slug);
  if (error) throw error;
  return data[0];
}
